import React from "react";

import { getPaymentDetails } from "../../../../redux/directoryMaintenance/paymentDetailsReducer/actionsPaymentDetails";

import GeneralSectionComponent from "../generalSectionComponent";
import PaymentDetailsModal from "./paymentDetailsModal/paymentDetailsModal";

import { PAYMENT_DETAILS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

function PaymentDetails() {
  return (
    <GeneralSectionComponent
      title="Реквизиты для оплаты"
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allPaymentDetails
      }
      getAction={getPaymentDetails}
      headerColumns={PAYMENT_DETAILS_COLUMNS}
      ModalComponent={PaymentDetailsModal}
    />
  );
}

export default PaymentDetails;
